import {} from '@angular/common';
import { NgModule } from '@angular/core';
import { CharacterLimitDirective } from './character-limit.directive';
import { NumericOperatorInputDirective } from './numerice.directive';
import { ScrollTrackerDirective } from './scroll.directive';
import { AlphabetsOnlyDirective } from './alphabet.directive';
import { UtcToLocalPipe } from './utc-local-time.pipe';
import { RemoveDecimalPipe } from '../pipes/remove-decimal.pipe';

@NgModule({
  declarations: [
    CharacterLimitDirective,
    NumericOperatorInputDirective,
    ScrollTrackerDirective,
    AlphabetsOnlyDirective,
    UtcToLocalPipe,
    RemoveDecimalPipe
  ],
  imports: [],
  exports: [
    AlphabetsOnlyDirective,
    CharacterLimitDirective,
    NumericOperatorInputDirective,
    ScrollTrackerDirective,
    UtcToLocalPipe,
    RemoveDecimalPipe,
  ],
})
export class DirectivesModule {}
